import { FC, ReactNode, useEffect } from 'react';

type Props = {
    readonly title?: string;
    readonly children?: ReactNode;
};

export const DocumentTitle: FC<Props> = ({ title, children }) => {
    useDocumentTitle(`${title ? `${title} | ` : ''}BorrowBox Connect`);
    return children ? <>{children}</> : null;
};

export default DocumentTitle;

function useDocumentTitle(title: string) {
    useEffect(() => {
        const originalTitle = document.title;
        document.title = title;
        return () => {
            document.title = originalTitle;
        };
    }, [title]);
}
